import React from 'react';
import { Link } from 'react-router-dom';
import EditProfileIcon from 'components/atoms/icons/editProfileIcon';
import path from 'constants/paths';
import PropTypes from 'prop-types';
import ProfileIcon from 'components/atoms/icons/profileIcon';

const Profile = ({ name, onClick }) => (
  <div className="menu-item-icon">
    <ProfileIcon className="menu-item-icon__icon menu-profile-icon" />
    <div className="menu-profile-title">
      <div>{name}</div>
      <div className="menu-item-icon__desc">My profile</div>
    </div>
    <Link
      to={path.profile}
      onClick={onClick}
      className="menu-profile-edit-icon"
    >
      <EditProfileIcon />
    </Link>
  </div>
);

Profile.defaultProps = {
  onClick: () => {},
};

Profile.propTypes = {
  onClick: PropTypes.func,
  name: PropTypes.string,
};

export default Profile;
